import { Tab, Tabs } from "@nextui-org/react";
import { useState } from "react";
import RevenueList from "./revenuelist";
import ReinvestmentConfig from "./reinvestmentconfig";
import ProviderRateConfig from "./providerrate";
import ShareConfig from "./shareconfig";

const GgrModule = () => {
  const [selectedTab, setSelectedTab] = useState("revenues");

  return (
    <div className="flex w-full flex-col justify-evenly">
      <Tabs
        variant="underlined"
        aria-label="User Module"
        className="w-full justify-start"
        classNames={{
          tabList: ["overflow-x-auto text-[#FFFFFF80]"],
          cursor: "user-module-selected",
          tabContent:
            "text-base font-bold group-data-[selected=true]:text-[#FFFFFF]",
        }}
        selectedKey={selectedTab}
        onSelectionChange={(key) => setSelectedTab(key as string)}
      >
        <Tab key="revenues" title="Revenues Calculation">
          <RevenueList />
        </Tab>
        <Tab key="providerrate" title="Provider Rates">
          <ProviderRateConfig />
        </Tab>
        <Tab key="reinvestment" title="Reinvestment">
          <ReinvestmentConfig />
        </Tab>
        <Tab key="shareconfig" title="Share Config">
          <ShareConfig />
        </Tab>
      </Tabs>
    </div>
  );
};

export default GgrModule;
